<template>
	<v-card>
		<v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
		<v-card-text class="pt-0">
			<v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="elevation-1"
				disable-pagination hide-default-footer item-key="id" loading-text="正在加载,请稍候......">
				
				
			</v-data-table>
			<div class="text-left pt-2">
				<v-row dense align="center">
					<v-col cols="2" >
						<v-select :items="[10, 20, 50, 100]" @change="handleSizeChange" dense hide-details label="每页数量"
							outlined v-model="query.size" />
					</v-col>
					<v-col cols="1">
						<span>共{{data.total}}项</span>
					</v-col>
					<v-col cols="9"   v-if="Math.ceil(data.total/query.size)>0">
						<v-pagination :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange"
							total-visible="10" v-model="query.page" />
					</v-col>
				</v-row>
			</div>
		</v-card-text>

		
		
	</v-card>
</template>

<script>

	import utils from "../../../config/utils"
	export default {
		name: "import-result-list",
		data() {
			return {

				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '教务管理',
						disabled: true
					},
					{
						text: '导入学员结果',
						disabled: true
					},
				],
				shopId:"",
				batchNo:"",
				data: {
					total: 0,
					headers: [
						{
							text: '学员名称',
							value: 'studentName',
							sortable: false
						},
						{
							text: '性别',
							value: 'genderName',
							sortable: false
						},
						{
							text: '年龄',
							value: 'age',
							sortable: false
						},
						{
							text: '联系人',
							value: 'contactorName',
							sortable: false
						},
						{
							text: '生源类型',
							value: 'studentSource',
							sortable: false
						},
						{
							text: '就读学校',
							value: 'fromSchool',
							sortable: false
						},
						{
							text: '居住片区',
							value: 'fromRegion',
							sortable: false
						},
						{
							text: '课程名称',
							value: 'courseName',
							sortable: false
						},
						{
							text: '班级名称',
							value: 'className',
							sortable: false
						},
						{
							text: '缴费金额',
							value: 'totalMoney',
							sortable: false
						},
						{
							text: '总课时',
							value: 'totalHours',
							sortable: false
						},
						{
							text: '已用课时',
							value: 'usedHours',
							sortable: false
						},
						{
							text: '赠送金额',
							value: 'giveTuition',
							sortable: false
						},
						{
							text: '已用金额',
							value: 'usdTuition',
							sortable: false
						},
						{
							text: '生源结果',
							value: 'createdSource',
							sortable: false
						},
						{
							text: '学员结果',
							value: 'createdStudent',
							sortable: false
						},
						{
							text: '分班结果',
							value: 'createdAccount',
							sortable: false
						},
						{
							text: '充值结果',
							value: 'addAccount',
							sortable: false
						},
						{
							text: '扣历史费用结果',
							value: 'reduceAccount',
							sortable: false
						},
						{
							text: '创建时间',
							value: 'createAt',
							sortable: false
						},
					],
					list: [],
				},
				query: {
					loading: false,
					page: 1,
					size: 20,
					shopId: ""
				},
				
			}
		},
		created() {
			this.batchNo = this.$route.params.batchNo;
			// 获取门店列表
			this.shopId = utils.getCurrentShopId();
			
			console.log("result page batchNO:"+this.batchNo);
			this.getTableDataList();
		},
		methods: {
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			showAddDialog() {
				this.add.dialog = true;
			},
			createRoomSuccess(){
				this.add.dialog= false;
				this.getTableDataList();
			},
			getTableDataList() {
				const that = this;
				this.query.loading = true;


				let url = `/edu/import/student/log/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
				if (this.batchNo) {
					url += "&batchNo=" + this.batchNo;
				}
				
				this.axios.get(url).then(response => {
					
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
		}
	}
</script>

<style>
</style>
